import { Carousel } from './carousel';

export class CarouselAlt extends Carousel {
  /**
   * css selector of carousel container
   * @static
   */
  static selector = '.js-carousel-alt';

  /**
   * Checks if container node is present in the dom
   * @function isOnPage
   * @returns {Boolean}
   * @static
   */
  static isOnPage() {
    return document.querySelector(CarouselAlt.selector);
  }

  constructor() {
    super();

    this.carousel = new Map();
    super.init(this, CarouselAlt.selector);
  }

  /**
   * Synchronizes accessibility attributes of slide icons based on the presence of video triggers.
   * @param {Node} carousel - DOM element of the carousel.
   */
  syncSlideTabindex = (carousel) => {
     $(carousel).find('.carousel-slide').each((index, el) => {
      const $slide = $(el);
      const hasVideo = $slide.find('.video-popup-image-wrapper-button').length > 0;

      if (hasVideo) {
        $slide.find('.svg-icon').attr({
          'tabindex': '-1',
          'aria-hidden': 'true'
        });
      }
    });
  }

  /**
   * Adds event listener for focus to activate the slide.
   * @param {Swiper} swiper - Swiper instance.
   * @param {Node} $carouselElement - DOM element of the carousel.
   */
  enableFocusSlideActivation(swiper, $carouselElement) {
    $carouselElement.addEventListener('focusin', (event) => {
      if (swiper.autoplay && swiper.autoplay.running) {
        const $playPauseBtn = $($carouselElement).find('.js-play-pause-box-btn');

        // Stop autoplay and sync UI state (icons/labels) when the carousel receives focus.
        if ($playPauseBtn.length > 0) {
          $playPauseBtn.trigger('click');
        } else {
          swiper.autoplay.stop();
        }
      }

      const slideElement = event.target.closest('.swiper-slide');

      if (slideElement && swiper && $carouselElement.contains(slideElement)) {
        const slideIndex = Array.from(swiper.slides).indexOf(slideElement);

        if (slideIndex > -1 && swiper.activeIndex !== slideIndex) {
          swiper.slideTo(slideIndex, 0);
        }

        // Reset container scroll to 0 to override native browser scroll-into-view on focus.
        // This ensures that the pagination and other controls remain visible.
        setTimeout(() => {
          $carouselElement.scrollLeft = 0;
          $carouselElement.scrollTop = 0;
        }, 0);
      }
    }, { capture: true });
  }

  /**
   * Generate config depending of the number of the slides in carousel by extending the default config
   * @param {Node} $carousel - Carousel DOM Node
   * @returns {Object} extended config
   */
  generateConfig($carousel) {
    if (super.hasSingleSlide($carousel)) {
      return super.extendConfig({
        pagination: false,
        loop: false,
        autoplay: false
      });
    }

    return super.extendConfig({
      autoplay: super.toggleAutoplay($carousel),
      loop: false,
      pagination: {
        el: $carousel.querySelector('.js-carousel-alt-pagination'),
        clickable: true,
        type: 'bullets',
        renderBullet: (index, className) => `<button class="${className}" aria-current="false" data-index="${index + 1}"></button>`
      },
      navigation: {
        nextEl: $carousel.querySelector('.swiper-button-next'),
        prevEl: $carousel.querySelector('.swiper-button-prev')
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        init: (swiper) => {
          const $pagination = $(swiper.pagination?.el);
          const $controlsNav = $(swiper.el).find('.carousel-controls');
          const baseLabel = $controlsNav.attr('data-aria-label') || 'Slide';

           if ($pagination.length) {
            $pagination.find('.swiper-pagination-bullet-active').attr('aria-current', 'true');
            $pagination.find('.swiper-pagination-bullet').each((index, el) => {
              const $bullet = $(el);
              const bulletIndex = $bullet.attr('data-index') || (index + 1);

              if (!$bullet.attr('aria-label')) {
                $bullet.attr('aria-label', `${baseLabel} ${bulletIndex}`);
              }
            });
          }

          this.syncSlideTabindex(swiper.el);
          this.enableFocusSlideActivation(swiper, swiper.el);
        },

        slideChange: (swiper) => {
          const $pagination = $(swiper.pagination?.el);

          if ($pagination.length) {
            $pagination.find('.swiper-pagination-bullet').each((index, el) => {
              const $bullet = $(el);
              const isActive = $bullet.hasClass('swiper-pagination-bullet-active');
              $bullet.attr('aria-current', isActive ? 'true' : 'false');
            });
          }
        }
      }
    });
  }
}